import {
  IonButton,
  IonButtons,
  IonHeader,
  IonIcon,
  IonModal,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import React from "react";
import RenderIframe from "../common/components/RenderIframe";
import { Capacitor } from "@capacitor/core";
import { closeOutline } from "ionicons/icons";

interface QuikStrikeProps {
  isQuikStrikeOpen: any;
  setIsQuikStrikeOpen: any;
}

const QuikStrike: React.FC<QuikStrikeProps> = ({
  isQuikStrikeOpen,
  setIsQuikStrikeOpen,
}) => {
  return (
    <IonModal isOpen={isQuikStrikeOpen} keepContentsMounted={false}>
      <IonHeader className="ion-no-border">
        <IonToolbar>
          <IonTitle>
            <p className="ion-no-margin text-bold">QUIKSTRIKE</p>
          </IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={() => setIsQuikStrikeOpen(false)}>
              <IonIcon
                icon={closeOutline}
                color="dark"
                slot="icon-only"
              ></IonIcon>
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <RenderIframe
        src={
          Capacitor.getPlatform() === "android"
            ? "https://cme-cards.quikstrike.net/User/CmeOneCard.aspx?insid=129516387&qsid=91b1e631-42e9-45ae-8d9e-fd3ed2b7f5af"
            : "https://cme-cards.quikstrike.net/User/CmeOneCard.aspx"
        }
        sandboxItems="allow-scripts allow-forms allow-same-origin allow-popups"
        title="Quick Strike Content"
        height="100%"
        width="100%"
        allowFullScreen={true}
        frameBorder="0"
      />
    </IonModal>
  );
};

export default QuikStrike;
